import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    (window as any)?.dataLayer?.push({
      event: 'virtual_page_view',
      pageURL: window.location.href,
    });
  }, [location]);

  return <Outlet />;
};
